import { useState } from 'react';
import { Box, Typography, IconButton, CameraAltIcon, CloseIcon, CropModal } from 'src/components';
import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

export default function ImageUpload({ 
    previewUrl, 
    onUpload,           // (file: File, preview: string) => void
    onClear,
    showClear = true,
    size = 160,
    aspect,
    circular = false
  }) {
    const [showCropModal, setShowCropModal] = useState(false);
    const [tempImageSrc, setTempImageSrc] = useState(null);

    const handlePick = async () => {
      let photo;

      if (Capacitor.isNativePlatform()) {
        photo = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Uri,
          source: CameraSource.Prompt,
          correctOrientation: true,
        });

        const response = await fetch(photo.webPath);
        const blob = await response.blob();
        setTempImageSrc(URL.createObjectURL(blob));
      } else {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = (e) => {
          const file = e.target.files?.[0];
          if (file) setTempImageSrc(URL.createObjectURL(file));
        };
        input.click();
      }

      setShowCropModal(true);
    };

    const handleCropComplete = (croppedFile) => {
      const preview = URL.createObjectURL(croppedFile);
      onUpload(croppedFile, preview);
    };

    return (
      <>
        <Box
          position="relative"
          width={size}
          height={size}
          border={previewUrl ? 'none' : '2px dashed #ccc'}
          borderRadius={circular ? '50%' : 2}
          overflow="hidden"
          sx={{ cursor: 'pointer' }}
          onClick={handlePick}
        >
          {previewUrl ? (
            <>
              <Box
                component="img"
                src={previewUrl}
                alt="Preview"
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              {showClear && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClear?.();
                  }}
                  sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'rgba(255,255,255,0.7)' }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </>
          ) : (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#888',
              }}
            >
              <CameraAltIcon sx={{ fontSize: size * 0.35, mb: 0.5 }} />
              <Typography variant="caption" color="text.secondary">
                Add Photo
              </Typography>
            </Box>
          )}
        </Box>

        <CropModal
          open={showCropModal}
          onClose={() => setShowCropModal(false)}
          imageSrc={tempImageSrc}
          aspect={circular ? 1 : aspect}
          onCropComplete={handleCropComplete}
        />
      </>
    );
}